module.exports = __webpack_public_path__ + "static/media/arun.35e64077.jpg";